import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';

import { ToastService } from '@shared/services/toast.service';
import { DriverService } from '../driver/services/driver.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss']
})
export class PaymentMethodComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  cardPaymentList:any = [];       
  bankPaymentList:any = [];
  paymentMethodSelected:string ='';
  activeItem:number = 0;
  items;
  @Input() driverId:string = "";
  constructor(
    private readonly driverService: DriverService,  
    private readonly toastService: ToastService
  ){

  }

ngOnInit(): void {
  this.getAllPatmentMethodList();
}

addDefulatDeletePaymentMethod(data) {
  this.items = [
    {
      items: [
        {
          label: '',
          icon: '',

        },
        {
          label: 'Set as default',
          icon: 'common-icon make-defult',
          escape: false,
          command: () => {
            this.SetDefualtPaymentMethod(data);
          }
        },
        {
          label: 'Delete',
          icon: 'common-icon custom-delete',
          escape: false,
          command: () => {
            this.deletePaymentMethod(data);
          }

        },
      ]
    },
  ];
}

  addPaymentMethod() {
    let DriverId = this.driverId
    const request= {
      driverId: DriverId,
      isBookingPopup: false
    }
    this.driverService.addPaymentMethodInRecurringCase(request)
      .pipe(
        autoUnsubWith(this.destroyRef)
      )
      .subscribe({
        next: (response) => {
          let paymentMethodRoutelink = response.data as string;
          window.location.href = paymentMethodRoutelink;

        }, error: () => {
        }
    })
  }

  getAllPatmentMethodList() {
    
    let DriverId = this.driverId
    this.driverService.getAllPatmentMethodsList(DriverId)
      .pipe(
        autoUnsubWith(this.destroyRef)
      )
      .subscribe({
        next: (response) => {
          if (response.data !=null){
          this.cardPaymentList = (response?.data['cards'])?response?.data['cards'] :[];
          this.bankPaymentList = (response?.data['banks'])?response?.data['banks']:[];
          this.paymentMethodSelected =
            this.cardPaymentList.find(card => card.isDefaultPaymentMethod) ||
            this.bankPaymentList.find(bank => bank.isDefaultPaymentMethod) ||
            [];
          
        }else{
          this.cardPaymentList = [];
          this.bankPaymentList = [];
        }

}, error: () => {
        this.cardPaymentList = [];
        this.bankPaymentList = [];
        
      }
    })
  }

  SetDefualtPaymentMethod(data) {
    let request = {
      paymentMethodId: data.id,
      driverId:this.driverId
    }
    this.driverService.setDefualtPaymentMethod(request)
      .pipe(
        autoUnsubWith(this.destroyRef)
      )
      .subscribe({
        next: (response) => {
          this.toastService.showToastMessage('success', 'Success', response?.message);
          this.getAllPatmentMethodList();
        }
    })
  };

deletePaymentMethod(data) {
    let request = {
      paymentMethodId: data.id,
      driverId: this.driverId
    }
    this.driverService.deletePaymentMethod(request)
      .pipe(
        autoUnsubWith(this.destroyRef)
      )
      .subscribe({
        next: (response) => {
          this.toastService.showToastMessage('success', 'Success', response?.message);
        this.getAllPatmentMethodList();
      }, error: (error) => {
        this.toastService.showToastMessage('success', 'Success', error?.error?.message)
      }
    })
  };

  getMonthName(monthNumber: number): string {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return months[monthNumber - 1] || "Invalid Month"; // monthNumber starts from 1, so subtract 1 for array index
  };

}
